module.exports = __webpack_public_path__ + "static/poster-3d65d3c2241b9e34b31d399c4cd42d59.svg";